import { Helmet } from 'react-helmet-async';

import "react-datepicker/dist/react-datepicker.css";
import SocialServiceClientBeneficiaryForm from './social_service_client_beneficiary_form';

import DatePicker from "react-datepicker";
import { useEffect, useRef, useState } from 'react';
import useScroll from '../../../hooks/useScroll';

import Swal from 'sweetalert2';
import useInsert from '../../../hooks/useInsert';
import { useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';

import useFormError from '../../../hooks/useFormErrorHighlight'

import moment from 'moment-timezone';


const formatDate = (date, timezone = 'Asia/Manila') => {
    const newDate = moment.tz(date, timezone);
    return newDate.format('YYYY-MM-DD');
  };
  
const SocialServiceAdd = ({personType,formData}) => {

    const navigate = useNavigate();

    const [selectedDate, setSelectedDate] = useState(null);

    const { category } = useParams();

    const { activeIndex, executeScroll } = useScroll(0);

    const links = [
        { label: 'Client details', iconClass: 'bx bxs-credit-card' },
        { label: 'Relationship', iconClass: 'bx bx-cart' },
        { label: 'Beneficiary details', iconClass: 'bx bxs-credit-card' },
        { label: 'Request Information', iconClass: 'bx bx-package' },
    ];




    const { insertData, isLoading, errorMessage, successMessage, responseData } = useInsert();

    const handleConfirmation = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to proceed?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'btn-info',
            cancelButtonColor: 'btn-secondary',
            confirmButtonText: 'Yes, proceed!',
            cancelButtonText: 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
        });

        if (result.isConfirmed) {
            const formData = {
                relationship_to_beneficiary: relationshipToBeneficiary,
                ss_type: category,
                ...clientFormData,
                ...beneficiaryFormData,
                ...requestData
            };

            try {
                await insertData(`${process.env.REACT_APP_API_URL}/socialservice/`, formData); 
            } catch (error) {
                console.error("Error inserting data:", error);
            }

            // Navigate or perform other actions here
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Handle cancellation if needed
        }

    };


    // IF THERE;S AN ERROR SCROLL TO TOP ALWAYS TO SHOW ERROR LISTS
    useEffect(() => {         
            if(errorMessage){
                setTimeout(() => {
                    scrollToTop();
                }, 750);
            } 
      }, [errorMessage])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
   
 

 
    
    //navigate(`./../../${category}/`);

    const [clientFormData, setClientFormData] = useState({
        client_fullname: "",
        client_isVoter: "",
        client_voter_id: "",
        client_email: "",
        client_contact: "",
        client_gender: "",
        client_birthdate: "",
        client_address: "",
        client_district: "",
        client_municipality: "",
        client_barangay: "",
        client_sitio: "",
        client_sector: "",
        client_father_name: "",
        client_mother_name: "",
        client_family_id: "",
        client_family_role: "",
    });

    const [relationshipToBeneficiary, setRelationshipToBeneficiary] = useState("");


    const [beneficiaryFormData, setBeneficiaryFormData] = useState({
        beneficiary_fullname: "",
        beneficiary_isVoter: "",
        beneficiary_voter_id: "",
        beneficiary_email: "",
        beneficiary_contact: "",
        beneficiary_gender: "",
        beneficiary_birthdate: "",
        beneficiary_address: "",
        beneficiary_district: "",
        beneficiary_municipality: "",
        beneficiary_barangay: "",
        beneficiary_sitio: "",
        beneficiary_sector: "",
        beneficiary_father_name: "",
        beneficiary_mother_name: "",
        beneficiary_family_id: "",
        beneficiary_family_role: "",
    });


    const [dateOfRequest, setDateOfRequest] = useState(null);
    const handleDateChangeDateOfRequest = (date) => {
        console.log(date);
        setDateOfRequest(date);

        setRequestData(prevRequestData => ({
            ...prevRequestData,
            date_request: formatDate(date)
          }));
      };

    const [requestData, setRequestData] = useState({
        amount: "",
        date_request: "",
        status: "",
        remarks: ""
    });





    // Update form data when child component changes its state
    const handleClientChange = (clientData) => {
        setClientFormData(prevData => ({
            ...prevData,
            ...clientData
        }));
    };

    const handleBeneficiaryChange = (beneficiaryData) => {
        
        setBeneficiaryFormData(prevData => ({
            ...prevData,
            ...beneficiaryData
        }));

    };


    const handleRelationshipChange = (e) => {
        setRelationshipToBeneficiary(e.target.value);
    };

    const handleRequestChange = (e) => {
        const { name, value } = e.target;
        setRequestData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };



    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const updateFormData = (date) => {
        const updatedFormData = {
          ...formData,
          [`${personType}_birthdate`]: date ? date.toISOString().split('T')[0] : "",
        };
        setRequestData(updatedFormData);
      };

    const formatFieldName = (fieldName) => {
        return fieldName.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    };

 

    
    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="py-3 mb-4"><span className="text-muted fw-light">Social Service /</span> Adding</h4>
                <div className="row g-4">


                    <div>

                        {successMessage && <p>{successMessage}</p>}
                        {errorMessage && errorMessage.errors && (

                            <div className="alert alert-danger alert-dismissible" role="alert">
                                <h6 className="alert-heading d-flex align-items-center mb-1">Error!!</h6>
                                <ul className='ps-0'>
                                    {/* {Object.values(errorMessage.errors).map((error, index) => (
                                        <p key={index} className="mb-0">{index}{error}</p>
                                    ))} */}

                                    <div className="row">
                                        {Object.entries(errorMessage.errors).map(([errorKey, errorMessages], index) => (
                                            <div key={index}  className="col-6"><p  className="mb-0"> <span className='text-black'>{formatFieldName(errorKey)}</span>  {errorMessages}</p></div>
                                        ))}
                                    </div>


                                    
                                </ul>

                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" />
                            </div>




                        )}


                    </div>


                    <div className="col-12 col-lg-4">

                        <div className="d-flex justify-content-between flex-column mb-3 mb-md-0">



                            <ul className="nav nav-align-left nav-pills flex-column">


                                {links.map((link, index) => (
                                    <li key={index} className="nav-item mb-1">
                                        <button onClick={() => executeScroll(index)} className={`nav-link ${activeIndex === index ? 'active' : ''}`}>
                                            <i className={link.iconClass + ' me-2'} />
                                            <span className="align-middle">{link.label}</span></button>
                                    </li>
                                ))}






                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8 pt-4 pt-lg-0">
                        <div className="tab-content p-0">
                            <div className="tab-pane fade show active" role="tabpanel">
 

                              


                                <SocialServiceClientBeneficiaryForm

                                    className="scroll-div"
                                    personType="client"
                                    onChange={handleClientChange}
                                    category={category}
                                    div_to_scroll_index="0"

                                    errorMessage={errorMessage}
                                />

                                <div className="card mb-4 scroll-div" id="div_to_scroll_1" >
                                    <div className="card-header">
                                        <h5 className="card-title m-0 text-primary">Relationship To Beneficiary</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">

                                            <div className="col-12">
                                                <select id="sel_relationship"
                                                    className="select2 form-select"
                                                    data-placeholder="Relationship"
                                                    name="sel_relationship" value={relationshipToBeneficiary}
                                                    onChange={(e) => setRelationshipToBeneficiary(e.target.value)}>
                                                    <option value="">Select Relationship</option>
                                                    <option value="Self">Self</option>
                                                    <option value="Parent">Parent</option>
                                                    <option value="Spouse">Spouse</option>
                                                    <option value="Child">Child</option>
                                                    <option value="Sibling">Sibling</option>
                                                    <option value="Grandparent">Grandparent</option>
                                                    <option value="Grandchild">Grandchild</option>
                                                    <option value="Aunt/Uncle">Aunt/Uncle</option>
                                                    <option value="Niece/Nephew">Niece/Nephew</option>
                                                    <option value="Cousin">Cousin</option>
                                                    <option value="Guardian">Guardian</option>
                                                    <option value="Foster Parent">Foster Parent</option>
                                                    <option value="Foster Child">Foster Child</option>
                                                    <option value="Step Parent">Step Parent</option>
                                                    <option value="Step Child">Step Child</option>
                                                    <option value="Adoptive Parent">Adoptive Parent</option>
                                                    <option value="Adopted Child">Adopted Child</option>
                                                    <option value="Neighbor">Neighbor</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <SocialServiceClientBeneficiaryForm
                                    className="scroll-div"
                                    personType="beneficiary"
                                    onChange={handleBeneficiaryChange}
                                    category={category}
                                    div_to_scroll_index="2"

                                    errorMessage={errorMessage}
                                />


                                <div className="card mb-4 scroll-div" id="div_to_scroll_3">
                                    <div className="card-header">
                                        <h5 className="card-title m-0 text-primary">Request information</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-12 col-md-6">
                                                <label className="form-label text-info mb-0" htmlFor="txt_amount">Amount</label>
                                                <input type="text" id="txt_amount" name="amount" className="form-control" placeholder="0.00" value={requestData.amount} onChange={handleRequestChange} />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label className="form-label text-info mb-0" htmlFor="date_request">Date Request</label>
                                              
                                            <DatePicker
                                                id="date_request"
                                                name="date_request"
                                                className="form-control flatpickr-input active"
                                                placeholderText="YYYY-MM-DD"
                                                selected={dateOfRequest}
                                                onChange={(date) => {
                                                    handleDateChangeDateOfRequest(date);
                                                }}
                                                dateFormat="yyyy-MM-dd"
                                            />


                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label className="form-label text-info mb-0" htmlFor="sel_status">Status</label>
                                                <select id="sel_status" name="status" className="select2 form-select" data-placeholder="Status" value={requestData.status} onChange={handleRequestChange}>
                                                    <option value=""></option>
                                                    <option value="For approval">For approval</option>
                                                    <option value="Approved">Approved</option>
                                                    <option value="Released">Released</option>
                                                    <option value="Denied">Denied</option>
                                                </select>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <label className="form-label text-info mb-0" htmlFor="txt_remarks">Remarks</label>
                                                <input type="text" id="txt_remarks" name="remarks" className="form-control" placeholder="Remarks" value={requestData.remarks} onChange={handleRequestChange} />
                                            </div>
                                        </div>
                                    </div>
                                </div>




                                <div className="d-flex justify-content-end gap-3">
                                    <button type="reset" className="btn btn-label-secondary">Discard</button>
                                    <button type="button" onClick={handleConfirmation} className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div >

        </>
    );
}

export default SocialServiceAdd;